module.exports = __webpack_public_path__ + "img/6-full-sm.395b4864.jpg";